import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, "群", -1)
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "right" }

import ListItem from "@/components/ChatItem.vue";
import Top from "@/components/Top.vue";
import { useRoute, useRouter } from "vue-router";
import { useGroupStore } from "@/store/groupStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const groupStore = useGroupStore();

const router = useRouter();
const route = useRoute();

groupStore.reloadGroupList();

const choose = (index: number, id: string) => {
  groupStore.checkIndex = index;
  router.push("/index/group/" + id);
};

const newGroup = () => {
  groupStore.checkIndex = -1;
  router.push("/index/group/new");
};

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 20 }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 4,
              class: "add"
            }, {
              default: _withCtx(() => [
                _createElementVNode("i", {
                  class: "iconfont icon-v-add",
                  title: "新建群",
                  onClick: _withModifiers(newGroup, ["stop"])
                }, null, 8, _hoisted_5)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_el_scrollbar, { class: "list" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(groupStore).groupList, (group, index) => {
            return (_openBlock(), _createBlock(ListItem, {
              key: group.id,
              id: group.id,
              img: group.avatar,
              username: group.name,
              showDel: false,
              active: index === _unref(groupStore).checkIndex,
              onClick: ($event: any) => (choose(index, group.id))
            }, null, 8, ["id", "img", "username", "active", "onClick"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(Top),
      (_openBlock(), _createBlock(_component_router_view, {
        class: "content",
        key: _unref(route).params.id
      }, {
        default: _withCtx(({ Component }) => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
        ]),
        _: 1
      }))
    ])
  ]))
}
}

})